(function () {
    'use strict';

    var $trees = $('.smp-decision-tree');

    if (!$trees.length) {
        return;
    }

    function getSteps($tree) {
        return $tree.find('.sq_question_wrapper');
    }

    function buildHeader($wrapper, stepNumber, totalSteps) {
        if ($wrapper.find('.smp-decision-tree__header').length) {
            return;
        }

        var $label = $wrapper.find('> div > label').first();

        if (!$label.length) {
            return;
        }

        var questionText = $.trim($label.text());
        var $header = $('<div class="smp-decision-tree__header"></div>');
        var $title = $('<p class="smp-decision-tree__question-title"></p>')
            .attr('data-step', stepNumber)
            .text(questionText);
        var $progress = $('<span class="smp-decision-tree__progress"></span>')
            .text(stepNumber + ' / ' + totalSteps);

        $header.append($title, $progress);
        $wrapper.prepend($header);
        $label.remove();
    }

    function showStep($tree, index) {
        var $steps = getSteps($tree);
        var maxIndex = $steps.length - 1;
        var nextIndex = Math.max(0, Math.min(index, maxIndex));

        $steps.removeClass('is-active').attr('hidden', true);
        $steps.eq(nextIndex).addClass('is-active').removeAttr('hidden');
        $tree.attr('data-current-step', nextIndex + 1);
    }

    function initMultiSelect($tree) {
        var maxChoices = 3;

        $tree.find('#q2, #q4').each(function () {
            var $section = $(this);
            var $wrapper = $section.find('.sq_question_wrapper').first();
            var $inputs = $wrapper.find('input.sq-form-field');

            $inputs.each(function () {
                if (this.type === 'radio') {
                    this.type = 'checkbox';
                }
            });

            if (!$wrapper.find('.smp-decision-tree__hint').length) {
                $wrapper.find('.smp-decision-tree__header').after(
                    '<p class="smp-decision-tree__hint">Select up to 3</p>'
                );
            }

            $wrapper.on('change', 'input[type="checkbox"]', function () {
                var $checked = $wrapper.find('input[type="checkbox"]:checked');

                if ($checked.length > maxChoices) {
                    this.checked = false;
                }
            });
        });
    }

    function initTree($tree) {
        var $steps = getSteps($tree);
        var totalSteps = $steps.length;

        $steps.each(function (index) {
            buildHeader($(this), index + 1, totalSteps);
        });

        initMultiSelect($tree);

        if ($tree.hasClass('smp-decision-tree--showcase')) {
            return;
        }

        showStep($tree, 0);
    }

    $trees.each(function () {
        initTree($(this));
    });
}());
